import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import state from '../store/app';

export default createReducer(state, {
  SET_PROJECT: (state, { data }) => Immutable({ ...state, projectId: data }),
  SET_DISTRICT: (state, { data }) => Immutable({ ...state, districtId: data }),
  SET_DISTRICTS: (state, { data }) => Immutable({ ...state, districts: data }),
  SET_LANG: (state, { data }) => Immutable({ ...state, lang: data }),
  SET_UUID: (state, { data }) => Immutable({ ...state, uuid: data }),
  SET_LOCALITY: (state, { data }) => Immutable({ ...state, localityId: data }),
  SET_PLUGINID: (state, { data }) => Immutable({ ...state, pluginId: data }),
});
